import type { SVGProps } from "react";

interface CrossIconProps extends SVGProps<SVGSVGElement> {
  withBg?: boolean;
  stroke?: string;
  strokeWidth?: number | string;
}

const CrossIcon = ({
  withBg = true,
  stroke = "#FF6961",
  strokeWidth = 1.25,
  viewBox,
  ...props
}: CrossIconProps) => {
  const defaultViewBox = withBg ? "0 0 32 32" : "8 8 16 16";

  return (
    <svg
      width="32"
      height="32"
      viewBox={viewBox || defaultViewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {withBg && <rect width="32" height="32" rx="16" fill="#FFF0EF" />}
      <path
        d="M21 11L11 21M11 11L21 21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CrossIcon;
